import { ref } from 'vue'

/**
 * 全局应用加载遮罩状态。
 * 登录成功跳转期间展示全屏 loading，覆盖目标页懒加载 chunk + 首屏挂载这段空白期。
 * 在 App.vue 挂载 <AppLoadingOverlay>，登录流程 setAppLoading(true)，
 * 路由 afterEach 到达目标页后 setAppLoading(false)。
 */
const visible = ref(false)
const text = ref('正在进入系统…')
let hideTimer: ReturnType<typeof setTimeout> | null = null

export function useAppLoading() {
  return { visible, text }
}

/** 打开全屏 loading。text 可选自定义文案。带最小展示时长，避免一闪而过。 */
export function setAppLoading(show: boolean, msg?: string) {
  if (hideTimer) {
    clearTimeout(hideTimer)
    hideTimer = null
  }
  if (show) {
    if (msg) text.value = msg
    visible.value = true
  } else {
    // 最小展示 400ms，防止目标页秒挂载导致闪烁
    hideTimer = setTimeout(() => {
      visible.value = false
      hideTimer = null
    }, 400)
  }
}
